import { render, staticRenderFns } from "./TypeSet.vue?vue&type=template&id=3e5957e8&scoped=true&"
import script from "./TypeSet.vue?vue&type=script&lang=ts&"
export * from "./TypeSet.vue?vue&type=script&lang=ts&"
import style0 from "./TypeSet.vue?vue&type=style&index=0&id=3e5957e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5957e8",
  null
  
)

export default component.exports